export default __webpack_public_path__ + "static/black-friday-comparison-table-d559eed5f2cd5fdeca5f77ee123df22a.pdf";